import React, { useEffect, useState } from "react";
import Drawer from "@mui/material/Drawer";
import Div from "@jumbo/shared/Div";
import useApp from "../../hooks/useApp";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import { useSelector } from "react-redux";
import { Autocomplete, TextField, Button, Checkbox } from "@mui/material";
import cloneDeep from "lodash.clonedeep";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { dispatch } from "app/store/store";
import {
  GetGlobalAccountsFilterList,
  GetGlobalAdvertisersFilterList,
  getGlobalBannersListThunk,
  getGlobalCampaignsListThunk,
} from "app/store/slice/common-slice";
import debounce from "lodash/debounce";
import {
  updateReportingFilters,
  updateReportingFiltersFormValues,
} from "app/store/slice/report-slice";
import { CenterFocusWeakTwoTone } from "@mui/icons-material";
import axiosApiInstance from "app/services/axios";
import { getDataEndPoint } from "app/utils/constants/paths";
import {
  updateCampaignFilters,
  updateCampaignFiltersFormValues,
  updateCampaignFiltersDateValues,
} from "app/store/slice/campaign-slice";
import VirtualizeAutocomplete from "app/Common/VirtualizeAutocomplete";
import BasicDateRangePicker from "app/Common/DateRangePicker";
import { DateRangePicker } from "rsuite";
import {
  startOfDay,
  endOfDay,
  addDays,
  subDays,
  startOfMonth,
  endOfMonth,
  subMonths,
  format,
  parseISO,
} from "date-fns";
import {
  convertDateFormat,
  getTodayDateBasedOnTimeZone,
} from "app/utils/utils";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const normalizeDateRangeValue = (value) => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === "string") {
    const parsed =
      value.includes("T") || value.includes("Z")
        ? parseISO(value)
        : new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const globalFilterStatusList = [
  { label: "Active", value: "0" },
  { label: "Paused", value: "1" },
  { label: "Expired", value: "3" },
  { label: "Draft", value: "-1" },
  { label: "Pinned", value: "pin" },
];

const CampaignFiltersCustomizer = () => {
  // const theme = useJumboTheme();
  const { customizerVisibility, setCustomizerVisibility } = useApp();
  const {
    globalAccountsList,
    globalAdvertisersList,
    globalPackagesList,
    globalCampaignsList,
    globalBannersList,
    authUserData,
    searchLoading,
    globalFilterAccountsList,
    globalFilterAdvertisersList,
    globalFilterCampaignsList,
    globalFilterBannersList,
  } = useSelector((state) => state.CommonReducer);

  const { campaignFilterFormValues } = useSelector(
    (state) => state.CampaignReducer
  );

  const [accountInputValue, setAccountInputValue] = useState("");
  const [advInputValue, setAdvInputValue] = useState("");

  const [campInputValue, setCampInputValue] = useState("");
  const [selectedDate, setSelectedDate] = React.useState([]);

  const [formValues, setFormValues] = useState({
    accounts: {
      source: globalAccountsList, //globalFilterAccountsList
      value: campaignFilterFormValues.accounts,
    },
    advertisers: {
      source: globalAdvertisersList, //globalFilterAdvertisersList,
      value: campaignFilterFormValues.advertisers,
    },
    packages: {
      source: globalPackagesList,
      value: campaignFilterFormValues.packages,
    },
    campaigns: {
      source: globalCampaignsList, //globalFilterCampaignsList,
      value: campaignFilterFormValues.campaigns,
    },
    status: {
      source: [
        { label: "Active", value: 0 },
        { label: "Paused", value: 1 },
        { label: "Expired", value: 3 },
        { label: "Draft", value: -1 },
      ],
      value: campaignFilterFormValues?.status,
    },
    startDate: { value: normalizeDateRangeValue(campaignFilterFormValues?.startDate) },
    endDate: { value: normalizeDateRangeValue(campaignFilterFormValues?.endDate) },
  });

  useEffect(() => {
    setFormValues((prevState) => {
      return {
        ...prevState,
        packages: { ...prevState.packages, source: globalPackagesList },
        campaigns: { ...prevState.campaigns, source: globalCampaignsList },
      };
    });
  }, [globalPackagesList, globalCampaignsList]);
  useEffect(() => {
    filterChildDropDown(
      "accounts",
      "advertisers",
      "account_id",
      globalAdvertisersList
    );
  }, [formValues.accounts.value]);

  useEffect(() => {
    filterChildDropDown("accounts", "packages", "accountid", globalPackagesList);
  }, [formValues.accounts.value, globalPackagesList]);

  useEffect(() => {
    filterChildDropDown(
      "advertisers",
      "campaigns",
      "advertiserid",
      globalCampaignsList
    );
  }, [formValues.advertisers.value]);

  const multiSelectChangeHandler = (name, value) => {
    let inputName = name;
    let inputValue = value != undefined && value != null ? value : "";
    setFormValues((prevState) => ({
      ...prevState,
      [inputName]: {
        ...prevState[inputName],
        value: inputValue,
      },
    }));
    dispatch(
      updateCampaignFiltersFormValues({ type: inputName, data: inputValue })
    );
  };
  let todayDate = new Date();
  const predefinedRanges = [
    {
      label: "today",
      value: [startOfDay(new Date(todayDate)), endOfDay(new Date(todayDate))],
    },
    {
      label: "yesterday",
      value: [
        startOfDay(addDays(new Date(todayDate), -1)),
        endOfDay(addDays(new Date(todayDate), -1)),
      ],
    },
    {
      label: "Last 7 Days",
      value: [
        startOfDay(subDays(new Date(todayDate), 6)),
        endOfDay(new Date(todayDate)),
      ],
    },
    {
      label: "Last 30 Days",
      value: [
        startOfDay(subDays(new Date(todayDate), 29)),
        endOfDay(new Date(todayDate)),
      ],
    },
    {
      label: "This Month",
      value: [
        startOfMonth(new Date(todayDate)),
        endOfMonth(new Date(todayDate)),
      ],
    },
    {
      label: "Last Month",
      value: [
        startOfMonth(subMonths(new Date(todayDate), 1)),
        endOfMonth(subMonths(new Date(todayDate), 1)),
      ],
    },
  ];
  const handleDateChange = (date) => {
    //let formValueUpdate = cloneDeep(formValues); // Make a deep copy of formValues

    setFormValues((prevState) => {
      return {
        ...prevState,
        startDate: {
          ...prevState.startDate,
          value: date != null ? date[0] : null,
        },
        endDate: { ...prevState.endDate, value: date != null ? date[1] : null },
      };
    });

    /* if (date !== null) {
      // If a new date range is selected
      formValueUpdate.startDate.value = date[0];
      formValueUpdate.endDate.value = date[1];
    } else {
      // If the date range is cleared
      formValueUpdate.startDate.value = null;
      formValueUpdate.endDate.value = null;
    }

    // Update the state with the new formValues

    setFormValues(formValueUpdate);
    dispatch(
      updateCampaignFiltersDateValues({
        startDate: date[0],
        endDate: date[1],
      })
    );
    */

    dispatch(
      updateCampaignFiltersDateValues({
        startDate: date ? date[0] : null,
        endDate: date ? date[1] : null,
      })
    );
  };

  const filterChildDropDown = (
    parentId,
    childId,
    childParentKey,
    childMasterData
  ) => {
    let selParentValuesArr = Array.isArray(formValues[parentId].value)
      ? formValues[parentId].value
      : [formValues[parentId].value];
    let selchildValuesArr = cloneDeep(formValues[childId].value);

    //console.log("Child Parent Key:", childParentKey);
    //console.log("Child Parent Values:", selParentValuesArr);

    if (selParentValuesArr <= 0) {
      selParentValuesArr = Array.isArray(formValues[parentId].source)
        ? formValues[parentId].source
        : [formValues[parentId].source];
    }

    let modChildList = childMasterData;
    //if (selParentValuesArr.length > 0) {
    modChildList = childMasterData.filter((item, index) => {
      return selParentValuesArr.some((v) => v.value == item[childParentKey]);
    });
    // }

    let selChildList = modChildList.filter((item, index) => {
      return selchildValuesArr.some((v) => v.value == item.value);
    });

    let finalObj = {};
    finalObj = {
      ...formValues,
      [childId]: {
        ...formValues[childId],
        source: modChildList,
        value: selChildList,
      },
    };
    setFormValues(finalObj);
  };

  const applyFilter = async (isClose = true) => {
    let accountsArr = [];
    let advertisersArr = [];
    let packagesArr = [];
    let campaignsArr = [];
    let statusArr = [];

    campaignFilterFormValues.accounts.map((accInfo) => {
      accountsArr.push(accInfo.value);
    });
    campaignFilterFormValues.advertisers.map((advInfo) => {
      advertisersArr.push(advInfo.value);
    });
    campaignFilterFormValues.packages.map((pkgInfo) => {
      packagesArr.push(pkgInfo.value);
    });
    campaignFilterFormValues.campaigns.map((campInfo) => {
      campaignsArr.push(campInfo.value);
    });
    campaignFilterFormValues.status.map((statusInfo) => {
      statusArr.push(statusInfo.value);
    });

    //If user is not system admin then we need to pass all the accounts/advertisers associated with that user.
    if (authUserData.is_sys_admin != "1") {
      accountsArr =
        accountsArr.length > 0
          ? accountsArr
          : globalAccountsList.map((accInfo) => {
              return accInfo.value;
            });

      advertisersArr =
        advertisersArr.length > 0
          ? advertisersArr
          : globalAdvertisersList.map((advInfo) => {
              return advInfo.value;
            });

      packagesArr =
        packagesArr.length > 0
          ? packagesArr
          : globalPackagesList.map((pkgInfo) => {
              return pkgInfo.value;
            });

      campaignsArr =
        campaignsArr.length > 0
          ? campaignsArr
          : globalCampaignsList.map((campInfo) => {
              return campInfo.value;
            });
      //If No Campaigns selected then we need to get the list of campaigns for that user.

      // try {
      //   let advStr =
      //     advertisersArr.length > 0
      //       ? "'" + advertisersArr.join("','") + "'"
      //       : "";
      //   let accntsStr =
      //     accountsArr.length > 0 ? "'" + accountsArr.join("','") + "'" : "";
      //   let WC = [];
      //   if (advStr != "") {
      //     WC.push(`advertiserid IN(${advStr})`);
      //   }
      //   if (accntsStr != "") {
      //     WC.push(`accountid IN(${accntsStr})`);
      //   }
      //   let whereCondition = WC.length > 0 ? " and " + WC.join(" and ") : "";

      //   let campQuery =
      //     "select id from consent.campaigns where status !='2' and (expire_time >= getdate() OR expire_time is null OR expire_time > getdate() - interval '6 months') " +
      //     whereCondition;

      //   const queryBody = {
      //     queries: [
      //       {
      //         //Get Open Requests Query
      //         query: campQuery,
      //         datasource: "redshift",
      //       },
      //     ],
      //   };

      //   let apiRes = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //   let response = await apiRes.data;
      //   if (response.error == false && response.results.length > 0) {
      //     let campsArr = response.results[0];
      //     let campaignsListArr = campsArr.map((item, index) => {
      //       return item.id;
      //     });
      //     campaignsArr = campaignsListArr;
      //   }
      //   // return response;
      // } catch (err) {
      //   // You can choose to use the message attached to err or write a custom error
      //   console.log("response", err);
      // }
    }

    let selFilters = {
      accounts: accountsArr,
      advertisers: advertisersArr,
      packages: packagesArr,
      campaigns: campaignsArr,
      status: statusArr,
      startDate: campaignFilterFormValues.startDate,
      endDate: campaignFilterFormValues.endDate,
    };
    dispatch(updateCampaignFilters(selFilters));
    // console.log("selFilters", selFilters);
    if (isClose != false) {
      setCustomizerVisibility(false);
    }
  };

  const clearFilter = (isClose = true) => {
    let finalObj = cloneDeep(formValues);
    finalObj.accounts.value = [];
    finalObj.advertisers.value = [];
    finalObj.packages.value = [];
    finalObj.campaigns.value = [];
    finalObj.status.value = [];
    setFormValues(finalObj);

    dispatch(updateCampaignFiltersFormValues({ action: "delete" }));

    let accountsArr = [];
    let advertisersArr = [];
    let packagesArr = [];
    let campaignsArr = [];
    let statusArr = [];
    //If user is not system admin then we need to pass all the accounts/advertisers associated with that user.
    if (authUserData.is_sys_admin != "1") {
      accountsArr =
        accountsArr.length > 0
          ? accountsArr
          : globalAccountsList.map((accInfo) => {
              return accInfo.value;
            });

      advertisersArr =
        advertisersArr.length > 0
          ? advertisersArr
          : globalAdvertisersList.map((advInfo) => {
              return advInfo.value;
            });

      packagesArr =
        packagesArr.length > 0
          ? packagesArr
          : globalPackagesList.map((pkgInfo) => {
              return pkgInfo.value;
            });

      // dispatch(
      //   getUsersCampaignsListThunk({ accounts, advertisers })
      // );
    }
    let selFilters = {
      accounts: accountsArr,
      advertisers: advertisersArr,
      packages: packagesArr,
      campaigns: campaignsArr,
      status: statusArr,
      startDate: campaignFilterFormValues.startDate,
      endDate: campaignFilterFormValues.endDate,
    };
    dispatch(updateCampaignFilters(selFilters));
    if (isClose != false) {
      setCustomizerVisibility(false);
    }
  };

  const getAccountsList = React.useMemo(
    () =>
      debounce((query) => {
        if (query.length > 1) {
          let search = query;
          let accounts = [];
          if (authUserData.is_sys_admin != 1) {
            let authAdvAccounts = authUserData?.user_assoc_accounts?.advertiser
              ? authUserData?.user_assoc_accounts?.advertiser
              : [];
            let authPubAccounts = authUserData?.user_assoc_accounts?.publisher
              ? authUserData?.user_assoc_accounts?.publisher
              : [];

            if (authAdvAccounts.length > 0 || authPubAccounts.length > 0) {
              accounts = [...authAdvAccounts, ...authPubAccounts];
            }
          }
          dispatch(GetGlobalAccountsFilterList({ accounts, search }));
        }
      }, 400),
    []
  );

  const getAdvertisersList = React.useMemo(
    () =>
      debounce((query) => {
        if (query.length > 1) {
          let search = query;
          let accFormValues = formValues.accounts.value;
          let accounts = [];
          let advertisers = [];
          if (authUserData.is_sys_admin != 1) {
            accounts =
              formValues.accounts.value.length > 0
                ? formValues.accounts.value.map((accInfo) => {
                    return accInfo.value;
                  })
                : [];
            advertisers = authUserData?.user_assoc_advertisers
              ? authUserData?.user_assoc_advertisers
              : [];
          } else {
            accounts =
              formValues.accounts.value.length > 0
                ? formValues.accounts.value.map((accInfo) => {
                    return accInfo.value;
                  })
                : [];
          }
          dispatch(
            GetGlobalAdvertisersFilterList({ accounts, advertisers, search })
          );
        }
      }, 400),
    [formValues.accounts.value]
  );

  const getCampaignsList = React.useMemo(
    () =>
      debounce((query) => {
        if (query.length > 1) {
          let search = query;
          let advFormValues = formValues.advertisers.value;
          let accFormValues = formValues.accounts.value;
          let advertisers = [];
          let accounts = [];
          accounts =
            accFormValues.length > 0
              ? accFormValues.map((accInfo) => {
                  return accInfo.value;
                })
              : [];

          advertisers =
            advFormValues.length > 0
              ? advFormValues.map((advInfo) => {
                  return advInfo.value;
                })
              : [];

          if (authUserData.is_sys_admin != 1) {
            if (accounts.length <= 0) {
              accounts = authUserData?.user_assoc_accounts?.advertiser
                ? authUserData?.user_assoc_accounts?.advertiser
                : [];
            }
            if (advertisers.length <= 0) {
              advertisers = authUserData.user_assoc_advertisers;
            }
          }
          dispatch(
            getGlobalCampaignsListThunk({ accounts, advertisers, search })
          );
        }
      }, 400),
    [formValues.accounts.value, formValues.advertisers.value]
  );

  const getBannersList = React.useMemo(
    () =>
      debounce((query) => {
        if (query.length > 1) {
          let search = query;
          let advFormValues = formValues.advertisers.value;
          let accFormValues = formValues.accounts.value;
          let campFormValues = formValues.campaigns.value;
          let advertisers = [];
          let accounts = [];
          let campaigns = [];
          accounts =
            accFormValues.length > 0
              ? accFormValues.map((accInfo) => {
                  return accInfo.value;
                })
              : [];

          advertisers =
            advFormValues.length > 0
              ? advFormValues.map((advInfo) => {
                  return advInfo.value;
                })
              : [];

          campaigns =
            campFormValues.length > 0
              ? campFormValues.map((campInfo) => {
                  return campInfo.value;
                })
              : [];

          if (authUserData.is_sys_admin != 1) {
            if (accounts.length <= 0) {
              accounts = authUserData?.user_assoc_accounts?.advertiser
                ? authUserData?.user_assoc_accounts?.advertiser
                : [];
            }
            if (advertisers.length <= 0) {
              advertisers = authUserData.user_assoc_advertisers;
            }
          }

          dispatch(
            getGlobalBannersListThunk({
              accounts,
              advertisers,
              campaigns,
              search,
            })
          );
        }
      }, 400),
    [
      formValues.accounts.value,
      formValues.advertisers.value,
      formValues.campaigns.value,
    ]
  );

  //To Apply Filters
  useEffect(() => {
    applyFilter();
  }, []);

  return (
    <Drawer
      anchor={"right"}
      open={customizerVisibility}
      onClose={() => setCustomizerVisibility(false)}
      sx={{
        zIndex: 1205,

        "& .MuiDrawer-paper": {
          width: 336,
        },
      }}
    >
      <Div
        sx={{
          display: "flex",
          minWidth: 0,
          position: "relative",
          zIndex: 2,
          p: (theme) => theme.spacing(1.5, 3),
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: 25,
        }}
      >
        <Typography variant={"h3"} mb={0} sx={{ fontSize: "14px" }}>
          Filters
        </Typography>
        <IconButton
          aria-label="close"
          onClick={() => setCustomizerVisibility(false)}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Div>
      <JumboScrollbar autoHide autoHideDuration={200} autoHideTimeout={500}>
        <Stack sx={{ px: 3, pt: 2 }}>
          {/* <Autocomplete
            id="Account"
            freeSolo={true}
            multiple
            disableClearable
            limitTags={2}
            filterOptions={(x) => x}
            loading={searchLoading}
            options={globalFilterAccountsList}
            getOptionLabel={(option) =>
              option.label ? option.label + " [ID:" + option.value + "]" : ""
            }
            renderOption={(props, option, { selected }) => (
              <li key={option.value} {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.label + " [ID:" + option.value + "]"}
              </li>
            )}
            value={
              formValues.accounts.value != "" ? formValues.accounts.value : []
            }
            onChange={(e, newValue) => {
              multiSelectChangeHandler("accounts", newValue);
            }}
            onInputChange={(event, newInputValue) => {
              setAccountInputValue(newInputValue);
              getAccountsList(newInputValue);
            }}
            inputValue={accountInputValue}
            renderInput={(params) => (
              <TextField
                {...params}
                id="Account"
                name="Account"
                label="Accounts"
                variant="standard"
                placeholder="Search Accounts"
                fullWidth
                sx={{ mb: 1 }}
                autoComplete="off"
              />
            )}
          /> */}
          {(authUserData.is_sys_admin == "1" ||
            globalAccountsList.length > 1) && (
            <VirtualizeAutocomplete
              id="Account"
              label="Accounts"
              placeholder="Search Accounts"
              list={globalAccountsList}
              selectedValues={
                formValues.accounts.value != "" ? formValues.accounts.value : []
              }
              multiSelectChangeHandler={multiSelectChangeHandler}
              inputName="accounts"
            />
          )}
          {/* <Autocomplete
            id="Advertiser"
            freeSolo={true}
            multiple
            disableClearable
            limitTags={2}
            filterOptions={(x) => x}
            loading={searchLoading}
            options={globalFilterAdvertisersList}
            disableCloseOnSelect
            getOptionLabel={(option) =>
              option.label ? option.label + " [ID:" + option.value + "]" : ""
            }
            renderOption={(props, option, { selected }) => (
              <li key={option.value} {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.label + " [ID:" + option.value + "]"}
              </li>
            )}
            value={
              formValues.advertisers.value != ""
                ? formValues.advertisers.value
                : []
            }
            onChange={(e, newValue) => {
              multiSelectChangeHandler("advertisers", newValue);
            }}
            onInputChange={(event, newInputValue) => {
              setAdvInputValue(newInputValue);
              getAdvertisersList(newInputValue);
            }}
            inputValue={advInputValue}
            renderInput={(params) => (
              <TextField
                {...params}
                id="Advertiser"
                name="Advertiser"
                label="Advertisers"
                variant="standard"
                placeholder="Search Advertisers"
                fullWidth
                sx={{ mb: 1 }}
                autoComplete="off"
              />
            )}
          /> */}
          {(authUserData.is_sys_admin == "1" ||
            globalAdvertisersList.length > 1) && (
            <VirtualizeAutocomplete
              id="Advertiser"
              label="Advertisers"
              placeholder="Search Advertisers"
              list={formValues.advertisers.source}
              selectedValues={
                formValues.advertisers.value != ""
                  ? formValues.advertisers.value
                  : []
              }
              multiSelectChangeHandler={multiSelectChangeHandler}
              inputName="advertisers"
            />
          )}
          {/* <Autocomplete
            id="Campaigns"
            freeSolo={true}
            multiple
            disableClearable
            limitTags={2}
            filterOptions={(x) => x}
            loading={searchLoading}
            options={globalFilterCampaignsList}
            disableCloseOnSelect
            getOptionLabel={(option) =>
              option.label ? option.label + " [ID:" + option.value + "]" : ""
            }
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.label + " [ID:" + option.value + "]"}
              </li>
            )}
            style={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                id="Campaigns"
                name="Campaigns"
                label="Campaigns"
                variant="standard"
                placeholder="Search Campaigns"
                fullWidth
                sx={{ mb: 1 }}
                autoComplete="off"
              />
            )}
            value={
              formValues.campaigns.value != "" ? formValues.campaigns.value : []
            }
            onInputChange={(event, newInputValue) => {
              setCampInputValue(newInputValue);
              getCampaignsList(newInputValue);
            }}
            inputValue={campInputValue}
            onChange={(e, newValue) => {
              multiSelectChangeHandler("campaigns", newValue);
            }}
            onBlur={(e, newValue) => {
              setCampInputValue("");
            }}
          /> */}
          {(authUserData.is_sys_admin == "1" ||
            globalPackagesList.length > 1) && (
            <VirtualizeAutocomplete
              id="Campaigns"
              label="Campaigns"
              placeholder="Search Campaigns"
              list={formValues.packages.source}
              selectedValues={
                formValues.packages.value != "" ? formValues.packages.value : []
              }
              multiSelectChangeHandler={multiSelectChangeHandler}
              inputName="packages"
            />
          )}
          {(authUserData.is_sys_admin == "1" ||
            globalCampaignsList.length > 1) && (
            <VirtualizeAutocomplete
              id="Campaigns"
              label="Ad Groups"
              placeholder="Search Ad Groups"
              list={formValues.campaigns.source}
              selectedValues={
                formValues.campaigns.value != ""
                  ? formValues.campaigns.value
                  : []
              }
              multiSelectChangeHandler={multiSelectChangeHandler}
              inputName="campaigns"
            />
          )}
          <Autocomplete
            id="Status"
            multiple
            disableClearable
            options={globalFilterStatusList}
            disableCloseOnSelect
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
            getOptionLabel={(option) => option.label}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.label + " [ID:" + option.value + "]"}
              </li>
            )}
            style={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                id="Status"
                name="Status"
                label="Status"
                variant="standard"
                placeholder="Select Status"
                fullWidth
                sx={{ mb: 1 }}
                autoComplete="off"
              />
            )}
            value={formValues.status.value != "" ? formValues.status.value : []}
            // onInputChange={(event, newInputValue) => {
            //   setBannerInputValue(newInputValue);
            //   getBannersList(newInputValue);
            // }}
            // inputValue={bannerInputValue}
            onChange={(e, newValue) => {
              multiSelectChangeHandler("status", newValue);
            }}
            // onBlur={(e, newValue) => {
            //   setBannerInputValue("");
            // }}
          />
          {/* <BasicDateRangePicker
            // updateDateRange={updateDateRange}
            // date={selDateRange}
            allowRanges={true}
          /> */}
          <Box sx={{ mt: 2 }}>
            <DateRangePicker
              size="md"
              placeholder="Select Date Range"
              placement={"auto"}
              character=" - "
              appearance={"subtle"}
              //showOneCalendar
              format="yyyy-MM-dd"
              value={[
                normalizeDateRangeValue(formValues.startDate.value),
                normalizeDateRangeValue(formValues.endDate.value),
              ]}
              cleanable={true}
              ranges={predefinedRanges}
              style={{
                //borderBottom: "2px solid #949494",
                border: "1px solid #ccc",
                borderRadius: "8px",
                marginBottom: "10px",
                width: "98%",
                marginRight: "16px",
              }}
              onChange={handleDateChange}
            />
          </Box>
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          sx={{ px: 3, pt: 2 }}
          spacing={2}
        >
          <Button variant="contained" onClick={applyFilter}>
            Apply
          </Button>
          <Button variant="contained" color="error" onClick={clearFilter}>
            Clear
          </Button>
        </Stack>
      </JumboScrollbar>
    </Drawer>
  );
};

export default CampaignFiltersCustomizer;
